// src/products/dataroom/components/Modals/CreateFolderModal.jsx
import React, { useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Modal for creating a new folder.
 * @param {object} props The component props.
 * @param {boolean} props.isOpen Whether the modal is open.
 * @param {function} props.onClose The function to call to close the modal.
 * @param {function} props.onCreateFolder The function to call to create the folder.
 */
const CreateFolderModal = ({ isOpen, onClose, onCreateFolder }) => {
  const [newFolderName, setNewFolderName] = useState('');

  const handleSubmit = () => {
    if (newFolderName.trim()) {
      onCreateFolder(newFolderName);
      setNewFolderName('');
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ease-in-out">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform transition-transform duration-300 scale-95 relative">
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h3 className="text-xl font-semibold text-gray-800">Create New Folder</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        
        <label htmlFor="folderName" className="block text-sm font-medium text-gray-700 mb-2">Folder Name</label>
        <input
          type="text"
          id="folderName"
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., Q1 2025 Financials"
        />
        <div className="flex justify-end mt-6 space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 bg-gray-200 rounded-full hover:bg-gray-300 transition-colors">
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors">
            Create
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreateFolderModal;
